import * as React from 'react';
import { PageTitle } from 'pages/Report/components/ReportPageLayout';
import RegistrationsPerAccount from './components/RegistrationsPerAccount';
import FactsOverview from './components/FactsOverview';
import RegistrationsPerDay from './components/RegistrationsPerDay';
import { Grid } from '@material-ui/core';
import { useIntl } from 'react-intl';
import GuestRegistrationsPerAccount from 'pages/Report/RegistrationFrequency/components/GuestRegistrationsPerAccount';

interface ComponentProps {
  downloadButton: React.ReactNode;
}

const RegistrationFrequency: React.FunctionComponent<ComponentProps> = ({ downloadButton }) => {
  const intl = useIntl();
  return (
    <>
      <PageTitle>{intl.formatMessage({ id: 'report.registrationFrequency.title' })}</PageTitle>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <FactsOverview />
        </Grid>
        <Grid item xs={12}>
          <RegistrationsPerDay />
        </Grid>
        <Grid item xs={12}>
          <RegistrationsPerAccount />
        </Grid>
        <Grid item xs={12}>
          <GuestRegistrationsPerAccount />
        </Grid>
      </Grid>
      {downloadButton}
    </>
  );
};

export default RegistrationFrequency;
